// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"86389f45","47":"849be8b4","228":"abd36693","288":"997aadd2","296":"2ee1b989","317":"ebb38636","324":"4050daab","452":"841a29b4","496":"74079093","590":"767cbcf7","867":"c3bb32a9","962":"ae19248c","986":"52a66dc9"}[chunkId] + ".chunk.js";
};